import type React from 'react';
import { useState } from 'react';

import { useOpenChat } from 'modules/ChatV2/store/OpenChatContext';
import { ChatReportModal } from 'modules/ChatV2/components/ChatReportModal';

type ChatReportMenuButtonProps = {
  className?: string;
  onBeforeOpen?: () => void;
};

/** Кнопка жалобы - только когда открыт чат с пользователем. */
export const ChatReportMenuButton: React.FC<ChatReportMenuButtonProps> = ({
  className,
  onBeforeOpen,
}) => {
  const { chatId, peerLabel } = useOpenChat();
  const [open, setOpen] = useState(false);

  if (chatId == null) return null;

  return (
    <>
      <button
        type='button'
        className={className}
        onClick={() => {
          onBeforeOpen?.();
          setOpen(true);
        }}
      >
        Пожаловаться на чат
      </button>
      <ChatReportModal
        open={open}
        onClose={() => setOpen(false)}
        chatId={chatId}
        peerLabel={peerLabel}
      />
    </>
  );
};
